<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-edit-member-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'EditMember',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreEditMemberView: () => import('../components/core/EditMemberView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
